import { number } from '~/helpers';

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  legend: { display: false },
  tooltips: {
    enabled: true,
    mode: 'index',
    intersect: false,
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#fff',
    titleFontColor: '#069',
    bodyFontColor: '#333',
    footerFontColor: '#333',
    callbacks: {
      label(tooltipItem, data) {
        return number(tooltipItem.value, 0);
      },
    },
  },
  layout: { padding: 0 },
  scales: {
    xAxes: [
      {
        stacked: true,
        barThickness: 50,
        maxBarThickness: 50,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
        ticks: {
          fontColor: '#333',
        },
        gridLines: {
          display: false,
          drawBorder: true,
        },
      },
    ],
    yAxes: [
      {
        stacked: true,
        ticks: {
          fontColor: '#333',
          beginAtZero: true,
          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: '#ccc',
          drawBorder: true,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: '#ccc',
        },
      },
    ],
  },
};
